import {
  DiscoverFilled,
  DiscoverOutline,
  PortfolioFilled,
  PortfolioOutline,
  WatchlistFilled,
  WatchlistOutline,
} from '@assets/svg'
import {
  HomeFilledTbcc,
  HomeOutlinedTbcc,
  ProfileFilledTbcc,
  ProfileOutlinedTbcc,
  TransactionsFilledTbcc,
  TransactionsFOutlineTbcc,
} from './assets'
import { MenuIcons } from 'interfaces'

export const TBCC_MENU_ICONS: MenuIcons = {
  discover: { filled: <DiscoverFilled />, outline: <DiscoverOutline /> },
  home: { filled: <HomeFilledTbcc />, outline: <HomeOutlinedTbcc /> },
  portfolio: { filled: <PortfolioFilled />, outline: <PortfolioOutline /> },
  profile: { filled: <ProfileFilledTbcc />, outline: <ProfileOutlinedTbcc /> },
  transactions: {
    filled: <TransactionsFilledTbcc />,
    outline: <TransactionsFOutlineTbcc />,
  },
  watchlist: { filled: <WatchlistFilled />, outline: <WatchlistOutline /> },
}
